const DEFAULT_OSS_BASE = 'https://hrws.s3.cn-east-2.jdcloud-oss.com'
const OSS_BASE = (process.env.VUE_APP_OSS_BASE || DEFAULT_OSS_BASE).replace(/\/+$/, '')

/** Bump when replacing static assets on OSS so long-lived caches fetch new URLs (use with CDN/OSS max-age). */
const STATIC_VERSION = (process.env.VUE_APP_STATIC_VERSION || '').trim()

export function oss(path) {
  if (!path) return ''
  const raw = String(path)
  if (/^https?:\/\//i.test(raw)) return raw
  const normalized = raw.replace(/^\/+/, '')
  let url = `${OSS_BASE}/${normalized}`
  // Do not append cache-bust query on video/audio — some CDNs/OSS treat ?v= as part of the key or break Range requests.
  const isMedia = /\.(mp4|webm|m4v|mov|ogv|mp3|m4a|ogg|wav)(\?|$)/i.test(normalized)
  if (STATIC_VERSION && !isMedia) {
    url += (url.includes('?') ? '&' : '?') + `v=${encodeURIComponent(STATIC_VERSION)}`
  }
  return url
}

export { OSS_BASE }
